import { Observable } from 'rxjs';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from '../shared/api-response.model';
import { ApiVisa } from '../shared/api-visa.model';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Pagination } from '../shared/pagination.model';


export class BaseApiPublicLoginTemplateService<BackofficeResponseType, PublicResponseType, LoginResponseType> extends BaseApiTemplateService<BackofficeResponseType> {
    public getByCriteriaPublic(
        pagination: Pagination,
        visa: ApiVisa
    ): Observable<PagingResponseModel<PublicResponseType>> {
        const publicApiUrl = this.endpoint_path_public_url && visa.api_domain_url ?
            visa.api_domain_url + this.endpoint_path_public_url
            : this.apiUrl;

        return this.__getByCriteriaAux<PublicResponseType>(publicApiUrl, pagination, visa);
    }

    public getByGuidPublic(
        guid: string,
        visa: ApiVisa
    ): Observable<BasicApiResponseModel<PublicResponseType>> {
        const publicApiUrl = this.endpoint_path_public_url && visa.api_domain_url ?
            visa.api_domain_url + this.endpoint_path_public_url
            : this.apiUrl;

        return this.__getByGuidAux<PublicResponseType>(publicApiUrl, guid, visa);
    }

    public getAllPublic(visa: ApiVisa): Observable<ApiResponseModel<PublicResponseType>> {
        const publicApiUrl = this.endpoint_path_public_url && visa.api_domain_url ?
            visa.api_domain_url + this.endpoint_path_public_url
            : this.apiUrl;

        return this.__getAllAux<PublicResponseType>(publicApiUrl, visa);
    }

    public getAllLoginEntity(visa: ApiVisa): Observable<ApiResponseModel<LoginResponseType>> {
        const loginEntityApiUrl = this.endpoint_path_login_entity_url && visa.api_domain_url ?
            visa.api_domain_url + this.endpoint_path_login_entity_url
            : this.apiUrl;

        return this.__getAllAux<LoginResponseType>(loginEntityApiUrl, visa);
    }

    public getByCriteriaLogin(
        pagination: Pagination,
        visa: ApiVisa
    ): Observable<PagingResponseModel<LoginResponseType>> {
        const loginApiUrl = this.endpoint_path_login_url && visa.api_domain_url ?
            visa.api_domain_url + this.endpoint_path_login_url
            : this.apiUrl;

        return this.__getByCriteriaAux<LoginResponseType>(loginApiUrl, pagination, visa)
    }

    public getByGuidLogin(
        guid: string,
        visa: ApiVisa
    ): Observable<BasicApiResponseModel<LoginResponseType>> {
        const loginApiUrl = this.endpoint_path_login_url && visa.api_domain_url ?
            visa.api_domain_url + this.endpoint_path_login_url
            : this.apiUrl;

        return this.__getByGuidAux<LoginResponseType>(loginApiUrl, guid, visa)
    }

    public getByGuidLoginEntity(
        guid: string,
        visa: ApiVisa
    ) : Observable<BasicApiResponseModel<LoginResponseType>> {
        const loginApiUrl = this.endpoint_path_login_entity_url && visa.api_domain_url ?
            visa.api_domain_url + this.endpoint_path_login_entity_url
            : this.apiUrl;

        return this.__getByGuidAux<LoginResponseType>(loginApiUrl, guid, visa) 
    }
    
    public getByCriteriaLoginEntity(
        pagination: Pagination,
        visa: ApiVisa
    ): Observable<PagingResponseModel<LoginResponseType>> {
        const loginEntityApiUrl = this.endpoint_path_login_entity_url && visa.api_domain_url ?
            visa.api_domain_url + this.endpoint_path_login_entity_url
            : this.apiUrl;

        return this.__getByCriteriaAux<LoginResponseType>(loginEntityApiUrl, pagination, visa)
    }

    public getByCriteriaLoginEntityWithEntityGuidParam(
        pagination: Pagination,
        visa: ApiVisa,
        entity_hdr_guid: string
    ): Observable<PagingResponseModel<LoginResponseType>> {
        const endpointUrl = this.endpoint_path_login_entity_url && visa.api_domain_url ?
            visa.api_domain_url + this.endpoint_path_login_entity_url
            : this.apiUrl;

        const UrlByCriteria = endpointUrl + '/query/' + entity_hdr_guid + "?" + pagination.getQueryKeyValues();
        return this.httpClient.get<PagingResponseModel<LoginResponseType>>(
            UrlByCriteria,
            this.getHttpHeader(visa)
        );
    }

    public postLoginEP(
        dtoObject: LoginResponseType,
        visa: ApiVisa
    ): Observable<BasicApiResponseModel<LoginResponseType>> {
        const loginApiUrl = this.endpoint_path_login_url && visa.api_domain_url ?
            visa.api_domain_url + this.endpoint_path_login_url
            : this.apiUrl;

        return this.__postLoginAux(loginApiUrl, dtoObject, visa);
    }

    public deleteLoginEP(
        guid: string, 
        visa: ApiVisa
    ): Observable<ApiResponseModel<LoginResponseType>> {
        const loginApiUrl = this.endpoint_path_login_url && visa.api_domain_url ?
            visa.api_domain_url + this.endpoint_path_login_url
            : this.apiUrl;

        return this.__deleteLoginAux(loginApiUrl, guid, visa);
      }
    
    public deleteLoginEntity(guid: string, visa: ApiVisa): Observable<ApiResponseModel<LoginResponseType>> {
        const loginEntityApiUrl = this.endpoint_path_login_entity_url && visa.api_domain_url ?
            visa.api_domain_url + this.endpoint_path_login_entity_url
            : this.apiUrl;

        return this.__deleteAux<LoginResponseType>(loginEntityApiUrl, guid, visa);
    }

    public putLoginEntityEP(
        dtoObject: LoginResponseType,
        visa: ApiVisa
    ): Observable<BasicApiResponseModel<LoginResponseType>> {
        const loginApiUrl = this.endpoint_path_login_entity_url && visa.api_domain_url ?
            visa.api_domain_url + this.endpoint_path_login_entity_url
            : this.apiUrl;

        return this.__putLoginEntityAux(loginApiUrl, dtoObject, visa);
    }

    public getByCriteriaWebsiteEp(
        pagination: Pagination,
        visa: ApiVisa,
        website_hdr_guid: string,
    ): Observable<PagingResponseModel<LoginResponseType>> {
        const endpointUrl = this.endpoint_path_website_ep_url && visa.api_domain_url ?
            visa.api_domain_url + this.endpoint_path_website_ep_url
            : this.apiUrl;

        const UrlByCriteria = endpointUrl + '/query/' + website_hdr_guid + "?" + pagination.getQueryKeyValues();
        return this.httpClient.get<PagingResponseModel<LoginResponseType>>(
            UrlByCriteria,
            this.getHttpHeader(visa)
        );
    }

    public getByCriteriaWebsiteEpV2(
        pagination: Pagination,
        visa: ApiVisa,
        website_hdr_guid: string,
    ): Observable<PagingResponseModel<LoginResponseType>> {
        const endpointUrl = this.endpoint_path_website_ep_url && visa.api_domain_url ?
            visa.api_domain_url + this.endpoint_path_website_ep_url
            : this.apiUrl;

        const UrlByCriteria = endpointUrl + "/" + website_hdr_guid +'/query?' + pagination.getQueryKeyValues();
        return this.httpClient.get<PagingResponseModel<LoginResponseType>>(
            UrlByCriteria,
            this.getHttpHeader(visa)
        );
    }

    public getByCriteriaWebsiteEP(
        pagination: Pagination,
        visa: ApiVisa
    ): Observable<PagingResponseModel<LoginResponseType>> {
        const websiteApiUrl = this.endpoint_path_website_ep_url && visa.api_domain_url ?
            visa.api_domain_url + this.endpoint_path_website_ep_url
            : this.apiUrl;

        return this.__getByCriteriaAux<LoginResponseType>(websiteApiUrl, pagination, visa)
    }

    public getByGuidWebsiteEP(
        guid: string,
        websiteGuid: string,
        visa: ApiVisa
    ): Observable<BasicApiResponseModel<LoginResponseType>> {
        const loginApiUrl = this.endpoint_path_website_ep_url && visa.api_domain_url ?
            visa.api_domain_url + this.endpoint_path_website_ep_url + '/' + websiteGuid
            : this.apiUrl;

        return this.__getByGuidAux<LoginResponseType>(loginApiUrl, guid, visa)
    }
}
